<template>
  <div id="govContract" class="container-fluid">
    <!-- //SECTION HeroImage -->
    <section class="row justify-content-center align-items-center heroImg">
      <div class="col-md-5 p-3">
        <!-- Mission Statement Section -->
        <section class="row p-2 pt-4 text-light rounded shadow bgStyle">
          <h1 class="fs-4 text-uppercase fw-bold">Veteran-Owned Software Development You Can Trust</h1>
          <h3 class="fs-3">Vassar & Smith Technologies LLC - Delivering Custom Software, Web Development, and Hosting Solutions with Over 30 Years of Experience</h3>
          <!-- Call to Action Button -->
           <div class="btn text-light button-style-two m-2" data-bs-toggle="modal" data-bs-target="#capabilitiesStatement">
            <a href="/capabilities-statement.pdf" download>Download Capabilities Statement</a>
           </div>
          <div>
            <button class="btn text-light button-style-two m-2" data-bs-toggle="modal" data-bs-target="#contactForm">
              Contact Us
            </button>
          </div>
        </section>
      </div>
    </section>
    <!-- //SECTION - Company Overview -->
    <section class="row justify-content-center p-5">
      <div class="col-md-9">
        <h2> Our Story</h2>
        <p>Founded in 2023, Vassar & Smith Technologies LLC began when our founder, Bryan Vassar, turned a career setback into an opportunity to improve how businesses approach their technology. After being laid off, Bryan saw a clear need: too many companies were stuck with outdated, ineffective websites and software. Partnering with a trusted colleague, we set out to create modern, high-performance solutions with speed, precision, and personal service.<br><br>Based in Idaho, SAM.gov registered, and proudly certified as an SDVOSB and VOSB, we serve both local businesses and national clients.</p>
      </div>
    </section>
    <!-- //SECTION - Core Competencies -->
    <section class="row">
      <div class="col-md-6">
        <h2> What We Do Best</h2>
        <p> <span class="mdi mdi-circle-medium"></span>Custom Web Development using Vue.js, React, and Node.js
<br>
            <span class="mdi mdi-circle-medium"></span>Website Hosting with secure, reliable infrastructure and full support
<br>
            <span class="mdi mdi-circle-medium"></span>Software & App Development using HTML, CSS, JavaScript, and C#
<br>
            <span class="mdi mdi-circle-medium"></span>Microsoft Azure Solutions for cloud deployment and optimization
<br>
            <span class="mdi mdi-circle-medium"></span>Ongoing Maintenance & Support to ensure performance and security</p>
      </div>
      <div class="col-md-6">
        <h2> Why Choose Us</h2>
        <p><span class="mdi mdi-circle-medium"></span>30+ years of combined software and web development experience
<br>
            <span class="mdi mdi-circle-medium"></span>Personalized service and fast turnaround times
<br>
            <span class="mdi mdi-circle-medium"></span>Specialized expertise with builders and real estate companies
<br>
            <span class="mdi mdi-circle-medium"></span>Tailored frameworks and solutions for each client’s unique needs
<br>
            <span class="mdi mdi-circle-medium"></span>Reputation for speed, professionalism, and exceptional customer care</p>
      </div>
    </section>
  </div>
</template>

<script>
</script>
<style scoped>
.heroImg {
  min-height: 80dvh;
  background-image: url("../assets/govHeroImg.jpg");
  background-blend-mode: lighten;
  background-size: cover;
  background-repeat: no-repeat;
}
</style>